<div [ngClass]="classes" [class.placeholder]="isPlaceholder">
  <div class="checkbox-image" [class.folder]="isFolder">
    @if (!small) {
      <div class="select-checkbox" [class.selected]="(file.selected || file.isChecked)">
        <mat-checkbox
          #selectCheckbox="matCheckbox"
          (click)="$event.stopPropagation()"
          (change)="triggerFileSelect(file)"
          [checked]="file.selected || file.isChecked"
          matTooltip="Bulk select"
          matTooltipShowDelay="500"
          matTooltipClass="menu-tooltip"
          matTooltipPosition="above"
          [attr.aria-labelledby]="'file-label-' + index"
        />
      </div>
    }
    <div class="image-container"
      [class.tw-d-none]="(file.selected || file.isChecked) && isFolder"
      [class.tw-bg-gray-50]="isPlaceholder">
      @if (isVideo) {
        <video preload="metadata">
          <source [src]="imgSrc" type="video/mp4">
        </video>
      } @else {
        <img [attr.aria-hidden]="isFolder" loading="lazy" alt="Image thumbnail" [src]="imgSrc"/>
      }
    </div>
  </div>
  @if (!small) {
    <div class="list-item-label tw-flex tw-flex-col" [class.tw-justify-center]="isFolder">
      <span id="file-label-{{index}}" class="tw-font-semibold tw-overflow-hidden tw-text-ellipsis">
        {{file.name | storageFileName:folderPath}}
      </span>
      @if (!isFolder) {
        <span class="tw-text-xl tw-text-gray-600">
          {{ file.timeCreated.value | date:'dd-MMM-yyyy' }} - {{ file.size | storageFileSize }}
        </span>
      }
    </div>
  }
</div>